import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { NETWORK_THREAT_PATH } from "@js2/path";
import { getRoute } from "@modules/network/components/common/NetworkLink";
import { useNetworkRoute } from "@modules/network/hooks/useNetworkRoute";

const MalwareFamilyInsightsNavItem = () => {
  const [name = "", value = ""] = useNetworkRoute();
  const route = getRoute(
    NETWORK_THREAT_PATH.MALWARE_FAMILY_INSIGHTS,
    name,
    value
  );

  return (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={route}
        key="malware-family-insights"
        eventKey="malware-family-insights"
      >
        Malware Family Insights
      </Nav.Link>
    </Nav.Item>
  );
};

export default MalwareFamilyInsightsNavItem;
